import React from "react";

import { containersStyles } from "./Styles";

const FilterContainer = ({children}) => {
    const styles = containersStyles();
    return(
        <div className={styles.filterContainer}>
            {children}
        </div>
    )
}

export default FilterContainer